/**
 * This file will convert signatures in markdown to html tags
 */

const rgxItalic = /(_)([^_]+?)(_)/gs;
const rgxBold = /(\*)([^*]+?)(\*)/gs;
const rgxStrikethrough = /(~)([^~]+?)(~)/gs;
const rgxUrl = /(https?:\/\/[^\s]+)/g;
const htmlItalic = "<i>$2</i>";
const htmlBold = "<b>$2</b>";
const htmlStrikethrough = "<s>$2</s>";
const htmlUrl = (url: string) =>
  '<a href="' + url + '" target="_blank">' + url + "</a>";

export const markdownConverter = (string: string) =>
  string
    ? string
        .replace(rgxBold, htmlBold)
        .replace(rgxItalic, htmlItalic)
        .replace(rgxStrikethrough, htmlStrikethrough)
        .replace(rgxUrl, htmlUrl)
    : string;
